import { Button } from "@sellar-io/components";
import { ReactElement } from "react";
import { Dialog, DialogNavigation, DialogCTA } from "../../modal/Dialog";

export function OrderRemoveBoxModal({
  onDelete,
  onDismiss,
  active,
}: {
  onDelete: () => void;
  onDismiss: () => void;
  active: boolean;
}): ReactElement {
  return (
    <Dialog active={active} onDismiss={onDismiss}>
      <DialogNavigation
        title={"Remove boxed item"}
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={onDismiss}
      />
      <DialogCTA>
        <Button color={"red"} onClick={onDelete}>
          Delete
        </Button>
      </DialogCTA>
    </Dialog>
  );
}
